import * as React from "react";

const Accordian2 = ({ color = "#61FF00" }) => (
  <svg width={1237} height={106} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1236 .5v58.834l-34.15 45.864-653.85.001H.5V36.287L38.214.501H986.5L1236 .5Z"
      stroke={color}
    />
  </svg>
);

export default Accordian2;
